import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Dashboard
export const AllTotalContact = createAsyncThunk(
  "common/dashboard/all-totalcontacts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTotalContact);

      return res?.data?.total_contacts || 0;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "totalcontacts",

  initialState: {
    totalcontacts: 0,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // Pending
      .addCase(AllTotalContact.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      // Success
      .addCase(AllTotalContact.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.totalcontacts = action.payload;
      })

      // Failed
      .addCase(AllTotalContact.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
